var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.theme.radio
  }, [_c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(3, 169, 244, .15)'),
      expression: "'rgba(3, 169, 244, .15)'"
    }],
    class: _vm.theme.radioOverlay,
    on: {
      "click": _vm.handleClick
    }
  }), _vm._v(" "), _c('radio-raw', {
    attrs: {
      "disabled": _vm.disabled,
      "value": _vm.value,
      "data": _vm.data
    }
  }), _vm._v(" "), _vm._t("label", [_c('span', {
    class: _vm.theme.label
  }, [_vm._v("\n            " + _vm._s(_vm.label) + "\n        ")])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-605ab5b5","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Radio/Radio.vue
// module id = 657
// module chunks = 0